import { Component, OnInit, Input } from '@angular/core';
import { ColumnDataTypeEnum } from '../../../enum/common/column-data-type.enum';
import { RoleCodeEnum } from '../../../enum/role-code.enum';
import { UserOperationalService } from '../../../services/user-operational.service';

@Component({
  selector: 'app-table-columns-generic',
  templateUrl: './table-columns-generic.component.html',
  styleUrls: ['./table-columns-generic.component.css']
})
export class TableColumnsGenericComponent implements OnInit {

  @Input() format: any;
  @Input() data: any;
  columnDataTypeEnum = ColumnDataTypeEnum;

  constructor(private userOperationalService: UserOperationalService) { }

  get canDisplayPhoneUnmasked(): boolean {
    return this.userOperationalService.hasPermissionByRoleCode(RoleCodeEnum.DISPLAY_CUSTOMER_PHONE_NUMBER_UNMASK);
  }

  ngOnInit() {
  }

}
